import React from "react"
import { motion } from "framer-motion"

type FadeInAnimationProps = {
  initialOpacity?: number;
  animateOpacity?: number;
  exitOpacity?: number;
  transitionDuration?: number;
  transitionEasing?: string;
  children: React.ReactNode;
}

export default function FadeInAnimation(props: FadeInAnimationProps) {
  const {
    initialOpacity = 0,
    animateOpacity = 1,
    exitOpacity = 0,
    transitionDuration = 0.2,
    transitionEasing = "easeInOut",
    children
  } = props

  return (
    <motion.div
      className="FadeInAnimation"
      initial={{ opacity: initialOpacity }}
      animate={{ opacity: animateOpacity }}
      exit={{ opacity: exitOpacity }}
      transition={{ duration: transitionDuration, ease: transitionEasing }}
      style={{ width: "100%", display: "flex", flexDirection:"column" }}
    >
      {children}
    </motion.div>
  )
}
